import React from 'react';
import PropTypes from 'prop-types';
import { aiDp } from '../../../../../utils/px2dp';
import { handlePrice } from '../../../../../utils/utils';
import {
  getColorSchemeStyle,
  DynamicColorValue,
} from '../../ColorSchemeV2';

// 纯 Web 版价格视图组件，对齐 RN 版 SHCardPriceView 的 props 和逻辑
let styles = pageStyles;

const SHCardPriceView = (props) => {
  const {
    isDark,
    price,
    kern,
    style = {},
    symbolStyle = {},
    mainPriceStyle = {},
    dotPriceStyle = {},
    unitPirceStyle = {}
  } = props;

  const {
    symbol = '¥',
    mainPrice = '',
    dotPrice = '',
    unitPrice = '',
  } = handlePrice(price);

  styles = getColorSchemeStyle(pageStyles, isDark)

  return (
    <div
      className='price-view'
      style={{
        ...styles.main,
        ...style,
      }}
    >
      <span
        className='symbol'
        style={{
          ...styles.symbol,
          ...symbolStyle,
        }}
      >
        {symbol}
      </span>
      <span
        className='main-price'
        style={{
          ...styles.mainPrice,
          ...mainPriceStyle,
          marginLeft: kern,
        }}
      >
        {mainPrice}
      </span>
      <span
        className='dot-price'
        style={{
          ...styles.dotPrice,
          ...dotPriceStyle,
        }}
      >
        {dotPrice}
      </span>
      <span
        className='unit-price'
        style={{
          ...styles.unitPirce,
          ...unitPirceStyle,
        }}
      >
        {unitPrice}
      </span>
    </div>
  );
};

const pageStyles = {
  main: {
    flexDirection: 'row'
  },
  symbol: {
    fontSize: aiDp(12),
    fontFamily: 'HelveticaNeue-CondensedBold',
    color: DynamicColorValue.dyc_333333,
  },
  mainPrice: {
    fontSize: aiDp(18),
    fontFamily: 'HelveticaNeue-CondensedBold',
    color: DynamicColorValue.dyc_333333,
  },
  dotPrice: {
    fontSize: aiDp(13),
    fontFamily: 'HelveticaNeue-CondensedBold',
    color: DynamicColorValue.dyc_333333,
  },
  unitPirce: {
    fontSize: aiDp(12),
    fontFamily: 'HelveticaNeue-CondensedBold',
    color: DynamicColorValue.dyc_333333,
  },
};

SHCardPriceView.propTypes = {
  price: PropTypes.string,
  fontSize: PropTypes.number, // 兼容 RN 版的 prop，当前未直接使用
  symbolFontSize: PropTypes.number, // 兼容 RN 版
  kern: PropTypes.number,
};

SHCardPriceView.defaultProps = {
  price: '--',
  fontSize: aiDp(18),
  symbolFontSize: aiDp(12),
  kern: 1,
};

export default SHCardPriceView;



// WEBPACK FOOTER //
// ./components/pipeline-recommend/lib/SHCard/widgets/SHCardPriceView.js